import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
//
export default function AlertDialog({ open, setOpen, title, content, positiveButtonLabel, negativeButtonLabel, callback }) {
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Dialog
      sx={{
        '& .MuiDialog-paper': {
          borderRadius: 7,
          py: 1.5,
          px: 1.5,
          backgroundColor: '#f1f4fa',
        },
      }}
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">
        {title}
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description" dangerouslySetInnerHTML={{ __html: content }}>

        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>{negativeButtonLabel}</Button>
        <Button onClick={() => {
          handleClose();
          if (callback) callback();
        }} autoFocus>
          {positiveButtonLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
}